// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Reviews-pageContent-iqYXX {
	max-width: var(--max-content-width);
	position: relative;
	display: block;
	margin: 0px auto;
	padding: 0px;
}

.Reviews-titleText-zjfsd {
	font-size: 30px;
	margin: 0px;
	color: var(--primary-foreground);
	font-weight: bold;
	word-break: break-word;
}

.Reviews-titleText-zjfsd:hover,
.Reviews-titleText-zjfsd:active,
.Reviews-titleText-zjfsd:focus {
	color: var(--primary-foreground);
	text-decoration: none;
}

.Reviews-sectionTitleText-s_AGY {
	font-size: 20px;
	margin: 0px;
	margin-bottom: 16px;
	font-weight: 600;
}

.Reviews-sectionTitleContent-F8IUl {
	font-size: 16px;
	color: var(--secondary-foreground);
}

.Reviews-sectionCaptionLink-suuis {
	font-size: 16px;
	color: var(--secondary-foreground);
}

a {
	cursor: pointer;
}

a:focus {
	outline: none;
}

.Reviews-textMuted-wONSz,
.Reviews-textMuted-wONSz:hover,
.Reviews-textMuted-wONSz:focus,
.Reviews-textMuted-wONSz:hover:focus {
	color: var(--secondary-foreground);
	text-decoration: none;
	font-size: inherit;
}

.Reviews-text-oj3VH {
	color: inherit;
	font-size: inherit;
	font-weight: normal;
}

.Reviews-textLine-TjZVc {
	text-decoration: line-through;
}

.Reviews-textCenter-ikDBu {
	text-align: center;
}

.Reviews-textError-kQRTg {
	color: var(--alert-color);
}

.Reviews-horizontalLineThrough-z398N {
	position: relative;
	display: block;
}

.Reviews-pageContent-iqYXX .Reviews-horizontalLineThrough-z398N:last-child {
	border-bottom: 0px;
}

.Reviews-space1-TOE1K {
	margin-bottom: 6px;
}

.Reviews-space2-fjxdm {
	margin-bottom: 12px;
}

.Reviews-space3-BUm8D {
	margin-bottom: 18px;
}

.Reviews-space4-r7oAD {
	margin-bottom: 24px;
}

.Reviews-space5-Jj0xE {
	margin-bottom: 48px;
}

.Reviews-spaceTop1-A3RF8 {
	margin-top: 6px;
}

.Reviews-spaceTop2-rWcIb {
	margin-top: 12px;
}

.Reviews-spaceTop3-NnHDr {
	margin-top: 18px;
}

.Reviews-spaceTop4-vcwlP {
	margin-top: 24px;
}

.Reviews-spaceTop5-CxjVw {
	margin-top: 48px;
}

.Reviews-padding1-dfmU_ {
	padding-bottom: 6px;
}

.Reviews-padding2-_oMve {
	padding-bottom: 12px;
}

.Reviews-padding3-vUdcq {
	padding-bottom: 18px;
}

.Reviews-padding4-xebYN {
	padding-bottom: 24px;
}

.Reviews-padding5-dW_B2 {
	padding-bottom: 48px;
}

.Reviews-paddingTop1-NGBAZ {
	padding-top: 6px;
}

.Reviews-paddingTop2-xgy1j {
	padding-top: 12px;
}

.Reviews-paddingTop3-Mlwd6 {
	padding-top: 18px;
}

.Reviews-paddingTop4-R5_Qf {
	padding-top: 24px;
}

.Reviews-paddingTop5-gBT6n {
	padding-top: 48px;
}

.Reviews-noMargin-W0GRP {
	margin: 0px;
}

.Reviews-noPadding-auIaM {
	padding: 0px;
}

.Reviews-noBorder-PqPH5 {
	border: 0px none !important;
}

.Reviews-btn-IS64f {
	padding: 7px 21px;
	border-color: var(--primary-border);
	background: var(--primary-color);
	color: var(--white-color);
	font-weight: bold;
	font-size: 16px;
	outline: none !important;
}

.Reviews-btnBlock-MOjiO {
	width: 100%;
	position: relative;
	white-space: normal;
	display: block;
}

.Reviews-btn-IS64f:hover,
.Reviews-btn-IS64f:focus,
.Reviews-btn-IS64f:hover:focus {
	background: transparent;
	color: var(--primary-foreground);
}

.Reviews-formControlSelect-lSeNd {
	margin-bottom: 8px;
}

.Reviews-splitList-x1YHH {
	display: inline-block;
	width: 50%;
	font-size: 16px;
	padding-right: 8px;
}

.Reviews-displayTable-rpy1a {
	display: table;
	width: 100%;
}

.Reviews-displayTableRow-jOlT1 {
	display: table-row;
	width: 100%;
}

.Reviews-displayTableCell-ZJJBo {
	display: table-cell;
	width: 100%;
}

.Reviews-displayTableCellIcon-UlyRB {
	display: table-cell;
	vertical-align: top;
}

.Reviews-textMutedNew-yvvSv {
	font-size: 16px;
	font-weight: 700;
	vertical-align: middle;
	word-break: break-word;
	line-height: 26px;
}

.Reviews-tableMarginTop-RG_53 {
	margin-top: 16px;
}

.Reviews-calendarTableCell-tR4nV {
	display: inline-block;
}

.Reviews-vrAlignTop-zhWma {
	vertical-align: top;
}

.Reviews-currenyMarginR-ZU9MK {
	margin-right: 6px;
}

.Reviews-sectionLink-pyvd5 {
	border: 1px solid var(--secondary-bg);
	padding: 10px;
	border-radius: 4px;
}

.Reviews-listingFontSize-rZJhr {
	font-size: 16px !important;
}

.Reviews-vrAlignBottom-XV_4G {
	vertical-align: bottom;
}

.Reviews-introTextPadding-5fATM {
	padding-left: 8px;
}

.Reviews-showHideBtn-LGcLa {
	-webkit-box-sizing: border-box !important;
	        box-sizing: border-box !important;
	margin: 0 !important;
	padding: 0px !important;
	width: auto !important;
	outline: 0 !important;
	background: transparent;
	color: var(--primary-link-foreground) !important;
	font-weight: inherit;
	word-wrap: break-word;
	line-height: 18px;
	letter-spacing: normal;
	font-size: 16px !important;
	border: 0px !important;
	text-decoration: underline;
}

.Reviews-showHideBtn-LGcLa.Reviews-focus-tTsaU,
.Reviews-showHideBtn-LGcLa:focus,
.Reviews-showHideBtn-LGcLa:active,
.Reviews-showHideBtn-LGcLa:active:focus,
.Reviews-showHideBtn-LGcLa:focus,
.Reviews-showHideBtn-LGcLa:hover {
	-webkit-box-sizing: border-box !important;
	        box-sizing: border-box !important;
	margin: 0 !important;
	padding: 0px !important;
	width: auto !important;
	outline: 0 !important;
	background: transparent !important;
	color: var(--primary-link-foreground) !important;
	font-weight: inherit;
	word-wrap: break-word;
	line-height: 18px;
	letter-spacing: normal;
	font-size: 16px;
	border: 0px !important;
}

.Reviews-showHideMargin-vrwBc {
	margin-bottom: 10px !important;
}

.Reviews-listingIntroWidth-KMLk6 {
	width: 65%;
}

.Reviews-showHidePadding-XH1gA {
	padding-bottom: 10px !important;
}

.Reviews-vtrTop-Ozr27 {
	vertical-align: top;
}

.Reviews-listingLine-JBcEA {
	border-top: 1px solid var(--primary-border);
	margin: 30px 0;
}

.Reviews-listingLineTwo-YOmmh {
	margin: 15px 0 30px;
}

@media screen and (max-width: 767px) {
	.Reviews-titleText-zjfsd {
		font-weight: 700;
		font-size: 26px;
		word-break: break-word;
	}

	.Reviews-splitList-x1YHH {
		display: inline-block;
		width: 100% !important;
	}

	.Reviews-listingIntroWidth-KMLk6 {
		width: 100% !important;
	}

	.Reviews-responsiveListIngIntro-o6fT7 {
		display: inline-block !important;
	}
}

.Reviews-space1-TOE1K {
	margin-bottom: 6px !important;
}

.Reviews-space2-fjxdm {
	margin-bottom: 12px !important;
}

.Reviews-space3-BUm8D {
	margin-bottom: 18px !important;
}

.Reviews-space4-r7oAD {
	margin-bottom: 24px !important;
}

.Reviews-space5-Jj0xE {
	margin-bottom: 30px !important;
}

.Reviews-space6-H4kQB {
	margin-bottom: 36px !important;
}

.Reviews-space7-tFRmD {
	margin-bottom: 42px !important;
}

.Reviews-spaceTop8-Ey6Ni {
	margin-bottom: 48px !important;
}

.Reviews-spaceTop1-A3RF8 {
	margin-top: 6px !important;
}

.Reviews-spaceTop2-rWcIb {
	margin-top: 12px !important;
}

.Reviews-spaceTop3-NnHDr {
	margin-top: 18px !important;
}

.Reviews-spaceTop4-vcwlP {
	margin-top: 24px !important;
}

.Reviews-spaceTop5-CxjVw {
	margin-top: 30px !important;
}

.Reviews-spaceTop6-WP8g3 {
	margin-top: 36px !important;
}

.Reviews-spaceTop7-qOcLN {
	margin-top: 42px !important;
}

.Reviews-spaceTop8-Ey6Ni {
	margin-top: 48px !important;
}

.Reviews-noMargin-W0GRP {
	margin: 0px !important;
}

.Reviews-padding1-dfmU_ {
	padding-bottom: 6px !important;
}

.Reviews-padding2-_oMve {
	padding-bottom: 12px !important;
}

.Reviews-padding3-vUdcq {
	padding-bottom: 18px !important;
}

.Reviews-padding4-xebYN {
	padding-bottom: 24px !important;
}

.Reviews-padding5-dW_B2 {
	padding-bottom: 30px !important;
}

.Reviews-padding6-kPTZJ {
	padding-bottom: 36px !important;
}

.Reviews-padding7-u7Siw {
	padding-bottom: 42px !important;
}

.Reviews-paddingTop1-NGBAZ {
	padding-top: 6px !important;
}

.Reviews-paddingTop2-xgy1j {
	padding-top: 12px !important;
}

.Reviews-paddingTop3-Mlwd6 {
	padding-top: 18px !important;
}

.Reviews-paddingTop4-R5_Qf {
	padding-top: 24px !important;
}

.Reviews-paddingTop5-gBT6n {
	padding-top: 30px !important;
}

.Reviews-paddingTop6-O7UC4 {
	padding-top: 36px !important;
}

.Reviews-paddingTop7-Z9Ro6 {
	padding-top: 42px !important;
}

.Reviews-noPadding-auIaM {
	padding: 0px !important;
}

.Reviews-textBold-epKP3 {
	font-weight: 500 !important;
}

.Reviews-textBolder-Jr9ef {
	font-weight: 700 !important;
}

.Reviews-textNormal-wTgbV {
	font-weight: normal !important;
}

.Reviews-spaceBottom20-y4gc5 {
	margin-bottom: 20px;
}

.Reviews-spaceBottom10-Kzff_ {
	margin-bottom: 10px;
}

.Reviews-marginNone-P8OwM {
	margin: 0;
}

.Reviews-spaceBottom15-S9dVJ {
	margin-bottom: 15px;
}

.Reviews-marginTopNone-chgmD {
	margin-top: 0;
}

.Reviews-spaceTop11-GsSak {
	margin-top: 11px;
}

.Reviews-spaceTop21-Iw6OE {
	margin-top: 21px;
}

.Reviews-spaceTop20-LYcub {
	margin-top: 20px;
}

.Reviews-spaceTop10-_fLKY {
	margin-top: 10px;
}

/*New Design Text Colors */

.Reviews-textDarkBlue-IiHEz {
	color: rgb(20, 39, 94) !important;
}

.Reviews-textLightBlue-B3phg {
	color: rgb(57, 87, 106) !important;
}

.Reviews-textLightSandleGreen-You9L {
	color: rgb(76, 86, 41) !important;
}

.Reviews-textLightBrown-him99 {
	color: rgb(115, 79, 33) !important;
}

.Reviews-textMediumMaroon-bsgpG {
	color: rgb(87, 37, 51) !important;
}

.Reviews-textBrown-jpYVy {
	color: rgb(160, 47, 24) !important;
}

.Reviews-textMaroon-BRfS8 {
	color: rgb(155, 49, 67) !important;
}

.Reviews-textDarkBrown-YBhbh {
	color: rgb(83, 18, 16) !important;
}

.Reviews-textMediumBrown-HhyZq {
	color: rgb(142, 28, 10) !important;
}

.Reviews-textSkyBlue-cYxIR {
	color: rgb(37, 117, 141) !important;
}

.Reviews-textGray-ExZyn {
	color: rgb(77, 65, 51) !important;
}

.Reviews-reviewContainer-PKntd {
	position: relative;
}

.Reviews-alignMiddle-ZNyxd {
	vertical-align: middle;
	display: table-cell;
}

.Reviews-mediaContainer-NbX_r {
	display: inline-block;
	position: relative;
}

.Reviews-profileAvatarLink-waG87 {
	-webkit-backface-visibility: hidden;
	        backface-visibility: hidden;
	position: relative;
	display: inline-block;
	overflow: hidden;
	border-radius: 50%;
	background-color: var(--secondary-gray-bg);
	border: 2px solid var(--primary-border);
}

.Reviews-avatarDisplay-EN10y {
	display: table-cell;
}

.Reviews-display-WLcFE {
	display: inline-block;
}

.Reviews-infoAlign-vqjgM {
	margin-left: 10px;
}

.Reviews-commentSection-N1QpU {
	margin: 20px 0px 0;
	word-wrap: break-word;
	font-size: 16px;
}

.Reviews-textBold-epKP3 {
	font-weight: 600 !important;
	font-size: 18px;
}

.Reviews-textLeft-qJmcv {
	margin-left: 5px;
}

.Reviews-horizontalLineThrough-z398N:last-child {
	border: 0px;
}

.Reviews-btnRadius-Cd9zf {
	border-radius: 0px;
}

.Reviews-linkBtn-OXr10 {
	border-radius: 4px;
	padding: 9px 21px;
}

a:hover,
a:focus,
a:active {
	text-decoration: none;
}

.Reviews-noBackground-h4j7M {
	background: transparent !important;
}

.Reviews-dateCss-gWAnl {
	color: var(--secondary-foreground);
	margin-top: 6px;
}

.Reviews-horizontalLineThrough-z398N {
	margin-top: 30px;
}

.Reviews-borderRadius-bObFQ {
	border-radius: 4px;
	margin-top: 25px;
	display: inline-block;
	font-weight: 400;

}

.Reviews-borderMarginTop-pPGlQ {
	margin-top: 30px;
}

.Reviews-sectionTitleText-s_AGY {
	font-size: 32px;
	color: var(--secondary-oscuro);
	font-family: var(--font-family-base);
	font-weight: bold;
}`, "",{"version":3,"sources":["webpack://./src/components/ViewListing/common.css","webpack://./src/components/helpers.css","webpack://./src/components/ViewListing/Reviews/Reviews.css"],"names":[],"mappings":"AAAA;CACC,mCAAmC;CACnC,kBAAkB;CAClB,cAAc;CACd,gBAAgB;CAChB,YAAY;AACb;;AAEA;CACC,eAAe;CACf,WAAW;CACX,gCAAgC;CAChC,iBAAiB;CACjB,sBAAsB;AACvB;;AAEA;;;CAGC,gCAAgC;CAChC,qBAAqB;AACtB;;AAEA;CACC,eAAe;CACf,WAAW;CACX,mBAAmB;CACnB,gBAAgB;AACjB;;AAEA;CACC,eAAe;CACf,kCAAkC;AACnC;;AAEA;CACC,eAAe;CACf,kCAAkC;AACnC;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,aAAa;AACd;;AAEA;;;;CAIC,kCAAkC;CAClC,qBAAqB;CACrB,kBAAkB;AACnB;;AAEA;CACC,cAAc;CACd,kBAAkB;CAClB,mBAAmB;AACpB;;AAEA;CACC,6BAA6B;AAC9B;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,kBAAkB;CAClB,cAAc;AACf;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,oBAAoB;AACrB;;AAEA;CACC,oBAAoB;AACrB;;AAEA;CACC,oBAAoB;AACrB;;AAEA;CACC,oBAAoB;AACrB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,iBAAiB;CACjB,mCAAmC;CACnC,gCAAgC;CAChC,yBAAyB;CACzB,iBAAiB;CACjB,eAAe;CACf,wBAAwB;AACzB;;AAEA;CACC,WAAW;CACX,kBAAkB;CAClB,mBAAmB;CACnB,cAAc;AACf;;AAEA;;;CAGC,uBAAuB;CACvB,gCAAgC;AACjC;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,qBAAqB;CACrB,UAAU;CACV,eAAe;CACf,kBAAkB;AACnB;;AAEA;CACC,cAAc;CACd,WAAW;AACZ;;AAEA;CACC,kBAAkB;CAClB,WAAW;AACZ;;AAEA;CACC,mBAAmB;CACnB,WAAW;AACZ;;AAEA;CACC,mBAAmB;CACnB,mBAAmB;AACpB;;AAEA;CACC,eAAe;CACf,gBAAgB;CAChB,sBAAsB;CACtB,sBAAsB;CACtB,iBAAiB;AAClB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,qBAAqB;AACtB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,qCAAqC;CACrC,aAAa;CACb,kBAAkB;AACnB;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,yCAAiC;SAAjC,iCAAiC;CACjC,oBAAoB;CACpB,uBAAuB;CACvB,sBAAsB;CACtB,qBAAqB;CACrB,uBAAuB;CACvB,gDAAgD;CAChD,oBAAoB;CACpB,qBAAqB;CACrB,iBAAiB;CACjB,sBAAsB;CACtB,0BAA0B;CAC1B,sBAAsB;CACtB,0BAA0B;AAC3B;;AAEA;;;;;;CAMC,yCAAiC;SAAjC,iCAAiC;CACjC,oBAAoB;CACpB,uBAAuB;CACvB,sBAAsB;CACtB,qBAAqB;CACrB,kCAAkC;CAClC,gDAAgD;CAChD,oBAAoB;CACpB,qBAAqB;CACrB,iBAAiB;CACjB,sBAAsB;CACtB,eAAe;CACf,sBAAsB;AACvB;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,UAAU;AACX;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,2CAA2C;CAC3C,cAAc;AACf;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC;EACC,gBAAgB;EAChB,eAAe;EACf,sBAAsB;CACvB;;CAEA;EACC,qBAAqB;EACrB,sBAAsB;CACvB;;CAEA;EACC,sBAAsB;CACvB;;CAEA;EACC,gCAAgC;CACjC;AACD;;ACnWA;CACC,6BAA6B;AAC9B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,SAAS;AACV;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA,0BAA0B;;AAE1B;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,mCAAmC;AACpC;;AAEA;CACC,iCAAiC;AAClC;;ACzNA;CACC,kBAAkB;AACnB;;AAEA;CACC,sBAAsB;CACtB,mBAAmB;AACpB;;AAEA;CACC,qBAAqB;CACrB,kBAAkB;AACnB;;AAEA;CACC,mCAA2B;SAA3B,2BAA2B;CAC3B,kBAAkB;CAClB,qBAAqB;CACrB,gBAAgB;CAChB,kBAAkB;CAClB,0CAA0C;CAC1C,uCAAuC;AACxC;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,qBAAqB;AACtB;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,kBAAkB;CAClB,qBAAqB;CACrB,eAAe;AAChB;;AAEA;CACC,2BAA2B;CAC3B,eAAe;AAChB;;AAGA;CACC,gBAAgB;AACjB;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,iBAAiB;AAClB;;AAEA;;;CAGC,qBAAqB;AACtB;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,kCAAkC;CAClC,eAAe;AAChB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,kBAAkB;CAClB,gBAAgB;CAChB,qBAAqB;CACrB,gBAAgB;;AAEjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,eAAe;CACf,8BAA8B;CAC9B,oCAAoC;CACpC,iBAAiB;AAClB","sourcesContent":[".pageContent {\n\tmax-width: var(--max-content-width);\n\tposition: relative;\n\tdisplay: block;\n\tmargin: 0px auto;\n\tpadding: 0px;\n}\n\n.titleText {\n\tfont-size: 30px;\n\tmargin: 0px;\n\tcolor: var(--primary-foreground);\n\tfont-weight: bold;\n\tword-break: break-word;\n}\n\n.titleText:hover,\n.titleText:active,\n.titleText:focus {\n\tcolor: var(--primary-foreground);\n\ttext-decoration: none;\n}\n\n.sectionTitleText {\n\tfont-size: 20px;\n\tmargin: 0px;\n\tmargin-bottom: 16px;\n\tfont-weight: 600;\n}\n\n.sectionTitleContent {\n\tfont-size: 16px;\n\tcolor: var(--secondary-foreground);\n}\n\n.sectionCaptionLink {\n\tfont-size: 16px;\n\tcolor: var(--secondary-foreground);\n}\n\na {\n\tcursor: pointer;\n}\n\na:focus {\n\toutline: none;\n}\n\n.textMuted,\n.textMuted:hover,\n.textMuted:focus,\n.textMuted:hover:focus {\n\tcolor: var(--secondary-foreground);\n\ttext-decoration: none;\n\tfont-size: inherit;\n}\n\n.text {\n\tcolor: inherit;\n\tfont-size: inherit;\n\tfont-weight: normal;\n}\n\n.textLine {\n\ttext-decoration: line-through;\n}\n\n.textCenter {\n\ttext-align: center;\n}\n\n.textError {\n\tcolor: var(--alert-color);\n}\n\n.horizontalLineThrough {\n\tposition: relative;\n\tdisplay: block;\n}\n\n.pageContent .horizontalLineThrough:last-child {\n\tborder-bottom: 0px;\n}\n\n.space1 {\n\tmargin-bottom: 6px;\n}\n\n.space2 {\n\tmargin-bottom: 12px;\n}\n\n.space3 {\n\tmargin-bottom: 18px;\n}\n\n.space4 {\n\tmargin-bottom: 24px;\n}\n\n.space5 {\n\tmargin-bottom: 48px;\n}\n\n.spaceTop1 {\n\tmargin-top: 6px;\n}\n\n.spaceTop2 {\n\tmargin-top: 12px;\n}\n\n.spaceTop3 {\n\tmargin-top: 18px;\n}\n\n.spaceTop4 {\n\tmargin-top: 24px;\n}\n\n.spaceTop5 {\n\tmargin-top: 48px;\n}\n\n.padding1 {\n\tpadding-bottom: 6px;\n}\n\n.padding2 {\n\tpadding-bottom: 12px;\n}\n\n.padding3 {\n\tpadding-bottom: 18px;\n}\n\n.padding4 {\n\tpadding-bottom: 24px;\n}\n\n.padding5 {\n\tpadding-bottom: 48px;\n}\n\n.paddingTop1 {\n\tpadding-top: 6px;\n}\n\n.paddingTop2 {\n\tpadding-top: 12px;\n}\n\n.paddingTop3 {\n\tpadding-top: 18px;\n}\n\n.paddingTop4 {\n\tpadding-top: 24px;\n}\n\n.paddingTop5 {\n\tpadding-top: 48px;\n}\n\n.noMargin {\n\tmargin: 0px;\n}\n\n.noPadding {\n\tpadding: 0px;\n}\n\n.noBorder {\n\tborder: 0px none !important;\n}\n\n.btn {\n\tpadding: 7px 21px;\n\tborder-color: var(--primary-border);\n\tbackground: var(--primary-color);\n\tcolor: var(--white-color);\n\tfont-weight: bold;\n\tfont-size: 16px;\n\toutline: none !important;\n}\n\n.btnBlock {\n\twidth: 100%;\n\tposition: relative;\n\twhite-space: normal;\n\tdisplay: block;\n}\n\n.btn:hover,\n.btn:focus,\n.btn:hover:focus {\n\tbackground: transparent;\n\tcolor: var(--primary-foreground);\n}\n\n.formControlSelect {\n\tmargin-bottom: 8px;\n}\n\n.splitList {\n\tdisplay: inline-block;\n\twidth: 50%;\n\tfont-size: 16px;\n\tpadding-right: 8px;\n}\n\n.displayTable {\n\tdisplay: table;\n\twidth: 100%;\n}\n\n.displayTableRow {\n\tdisplay: table-row;\n\twidth: 100%;\n}\n\n.displayTableCell {\n\tdisplay: table-cell;\n\twidth: 100%;\n}\n\n.displayTableCellIcon {\n\tdisplay: table-cell;\n\tvertical-align: top;\n}\n\n.textMutedNew {\n\tfont-size: 16px;\n\tfont-weight: 700;\n\tvertical-align: middle;\n\tword-break: break-word;\n\tline-height: 26px;\n}\n\n.tableMarginTop {\n\tmargin-top: 16px;\n}\n\n.calendarTableCell {\n\tdisplay: inline-block;\n}\n\n.vrAlignTop {\n\tvertical-align: top;\n}\n\n.currenyMarginR {\n\tmargin-right: 6px;\n}\n\n.sectionLink {\n\tborder: 1px solid var(--secondary-bg);\n\tpadding: 10px;\n\tborder-radius: 4px;\n}\n\n.listingFontSize {\n\tfont-size: 16px !important;\n}\n\n.vrAlignBottom {\n\tvertical-align: bottom;\n}\n\n.introTextPadding {\n\tpadding-left: 8px;\n}\n\n.showHideBtn {\n\tbox-sizing: border-box !important;\n\tmargin: 0 !important;\n\tpadding: 0px !important;\n\twidth: auto !important;\n\toutline: 0 !important;\n\tbackground: transparent;\n\tcolor: var(--primary-link-foreground) !important;\n\tfont-weight: inherit;\n\tword-wrap: break-word;\n\tline-height: 18px;\n\tletter-spacing: normal;\n\tfont-size: 16px !important;\n\tborder: 0px !important;\n\ttext-decoration: underline;\n}\n\n.showHideBtn.focus,\n.showHideBtn:focus,\n.showHideBtn:active,\n.showHideBtn:active:focus,\n.showHideBtn:focus,\n.showHideBtn:hover {\n\tbox-sizing: border-box !important;\n\tmargin: 0 !important;\n\tpadding: 0px !important;\n\twidth: auto !important;\n\toutline: 0 !important;\n\tbackground: transparent !important;\n\tcolor: var(--primary-link-foreground) !important;\n\tfont-weight: inherit;\n\tword-wrap: break-word;\n\tline-height: 18px;\n\tletter-spacing: normal;\n\tfont-size: 16px;\n\tborder: 0px !important;\n}\n\n.showHideMargin {\n\tmargin-bottom: 10px !important;\n}\n\n.listingIntroWidth {\n\twidth: 65%;\n}\n\n.showHidePadding {\n\tpadding-bottom: 10px !important;\n}\n\n.vtrTop {\n\tvertical-align: top;\n}\n\n.listingLine {\n\tborder-top: 1px solid var(--primary-border);\n\tmargin: 30px 0;\n}\n\n.listingLineTwo {\n\tmargin: 15px 0 30px;\n}\n\n@media screen and (max-width: 767px) {\n\t.titleText {\n\t\tfont-weight: 700;\n\t\tfont-size: 26px;\n\t\tword-break: break-word;\n\t}\n\n\t.splitList {\n\t\tdisplay: inline-block;\n\t\twidth: 100% !important;\n\t}\n\n\t.listingIntroWidth {\n\t\twidth: 100% !important;\n\t}\n\n\t.responsiveListIngIntro {\n\t\tdisplay: inline-block !important;\n\t}\n}",".space1 {\n\tmargin-bottom: 6px !important;\n}\n\n.space2 {\n\tmargin-bottom: 12px !important;\n}\n\n.space3 {\n\tmargin-bottom: 18px !important;\n}\n\n.space4 {\n\tmargin-bottom: 24px !important;\n}\n\n.space5 {\n\tmargin-bottom: 30px !important;\n}\n\n.space6 {\n\tmargin-bottom: 36px !important;\n}\n\n.space7 {\n\tmargin-bottom: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-bottom: 48px !important;\n}\n\n.spaceTop1 {\n\tmargin-top: 6px !important;\n}\n\n.spaceTop2 {\n\tmargin-top: 12px !important;\n}\n\n.spaceTop3 {\n\tmargin-top: 18px !important;\n}\n\n.spaceTop4 {\n\tmargin-top: 24px !important;\n}\n\n.spaceTop5 {\n\tmargin-top: 30px !important;\n}\n\n.spaceTop6 {\n\tmargin-top: 36px !important;\n}\n\n.spaceTop7 {\n\tmargin-top: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-top: 48px !important;\n}\n\n.noMargin {\n\tmargin: 0px !important;\n}\n\n.padding1 {\n\tpadding-bottom: 6px !important;\n}\n\n.padding2 {\n\tpadding-bottom: 12px !important;\n}\n\n.padding3 {\n\tpadding-bottom: 18px !important;\n}\n\n.padding4 {\n\tpadding-bottom: 24px !important;\n}\n\n.padding5 {\n\tpadding-bottom: 30px !important;\n}\n\n.padding6 {\n\tpadding-bottom: 36px !important;\n}\n\n.padding7 {\n\tpadding-bottom: 42px !important;\n}\n\n.paddingTop1 {\n\tpadding-top: 6px !important;\n}\n\n.paddingTop2 {\n\tpadding-top: 12px !important;\n}\n\n.paddingTop3 {\n\tpadding-top: 18px !important;\n}\n\n.paddingTop4 {\n\tpadding-top: 24px !important;\n}\n\n.paddingTop5 {\n\tpadding-top: 30px !important;\n}\n\n.paddingTop6 {\n\tpadding-top: 36px !important;\n}\n\n.paddingTop7 {\n\tpadding-top: 42px !important;\n}\n\n.noPadding {\n\tpadding: 0px !important;\n}\n\n.textBold {\n\tfont-weight: 500 !important;\n}\n\n.textBolder {\n\tfont-weight: 700 !important;\n}\n\n.textNormal {\n\tfont-weight: normal !important;\n}\n\n.spaceBottom20 {\n\tmargin-bottom: 20px;\n}\n\n.spaceBottom10 {\n\tmargin-bottom: 10px;\n}\n\n.marginNone {\n\tmargin: 0;\n}\n\n.spaceBottom15 {\n\tmargin-bottom: 15px;\n}\n\n.marginTopNone {\n\tmargin-top: 0;\n}\n\n.spaceTop11 {\n\tmargin-top: 11px;\n}\n\n.spaceTop21 {\n\tmargin-top: 21px;\n}\n\n.spaceTop20 {\n\tmargin-top: 20px;\n}\n\n.spaceTop10 {\n\tmargin-top: 10px;\n}\n\n/*New Design Text Colors */\n\n.textDarkBlue {\n\tcolor: rgb(20, 39, 94) !important;\n}\n\n.textLightBlue {\n\tcolor: rgb(57, 87, 106) !important;\n}\n\n.textLightSandleGreen {\n\tcolor: rgb(76, 86, 41) !important;\n}\n\n.textLightBrown {\n\tcolor: rgb(115, 79, 33) !important;\n}\n\n.textMediumMaroon {\n\tcolor: rgb(87, 37, 51) !important;\n}\n\n.textBrown {\n\tcolor: rgb(160, 47, 24) !important;\n}\n\n.textMaroon {\n\tcolor: rgb(155, 49, 67) !important;\n}\n\n.textDarkBrown {\n\tcolor: rgb(83, 18, 16) !important;\n}\n\n.textMediumBrown {\n\tcolor: rgb(142, 28, 10) !important;\n}\n\n.textSkyBlue {\n\tcolor: rgb(37, 117, 141) !important;\n}\n\n.textGray {\n\tcolor: rgb(77, 65, 51) !important;\n}","@import '../common.css';\n@import '../../helpers.css';\n\n.reviewContainer {\n\tposition: relative;\n}\n\n.alignMiddle {\n\tvertical-align: middle;\n\tdisplay: table-cell;\n}\n\n.mediaContainer {\n\tdisplay: inline-block;\n\tposition: relative;\n}\n\n.profileAvatarLink {\n\tbackface-visibility: hidden;\n\tposition: relative;\n\tdisplay: inline-block;\n\toverflow: hidden;\n\tborder-radius: 50%;\n\tbackground-color: var(--secondary-gray-bg);\n\tborder: 2px solid var(--primary-border);\n}\n\n.avatarDisplay {\n\tdisplay: table-cell;\n}\n\n.display {\n\tdisplay: inline-block;\n}\n\n.infoAlign {\n\tmargin-left: 10px;\n}\n\n.commentSection {\n\tmargin: 20px 0px 0;\n\tword-wrap: break-word;\n\tfont-size: 16px;\n}\n\n.textBold {\n\tfont-weight: 600 !important;\n\tfont-size: 18px;\n}\n\n\n.textLeft {\n\tmargin-left: 5px;\n}\n\n.horizontalLineThrough:last-child {\n\tborder: 0px;\n}\n\n.btnRadius {\n\tborder-radius: 0px;\n}\n\n.linkBtn {\n\tborder-radius: 4px;\n\tpadding: 9px 21px;\n}\n\na:hover,\na:focus,\na:active {\n\ttext-decoration: none;\n}\n\n.noBackground {\n\tbackground: transparent !important;\n}\n\n.dateCss {\n\tcolor: var(--secondary-foreground);\n\tmargin-top: 6px;\n}\n\n.horizontalLineThrough {\n\tmargin-top: 30px;\n}\n\n.borderRadius {\n\tborder-radius: 4px;\n\tmargin-top: 25px;\n\tdisplay: inline-block;\n\tfont-weight: 400;\n\n}\n\n.borderMarginTop {\n\tmargin-top: 30px;\n}\n\n.sectionTitleText {\n\tfont-size: 32px;\n\tcolor: var(--secondary-oscuro);\n\tfont-family: var(--font-family-base);\n\tfont-weight: bold;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"pageContent": `Reviews-pageContent-iqYXX`,
	"titleText": `Reviews-titleText-zjfsd`,
	"sectionTitleText": `Reviews-sectionTitleText-s_AGY`,
	"sectionTitleContent": `Reviews-sectionTitleContent-F8IUl`,
	"sectionCaptionLink": `Reviews-sectionCaptionLink-suuis`,
	"textMuted": `Reviews-textMuted-wONSz`,
	"text": `Reviews-text-oj3VH`,
	"textLine": `Reviews-textLine-TjZVc`,
	"textCenter": `Reviews-textCenter-ikDBu`,
	"textError": `Reviews-textError-kQRTg`,
	"horizontalLineThrough": `Reviews-horizontalLineThrough-z398N`,
	"space1": `Reviews-space1-TOE1K`,
	"space2": `Reviews-space2-fjxdm`,
	"space3": `Reviews-space3-BUm8D`,
	"space4": `Reviews-space4-r7oAD`,
	"space5": `Reviews-space5-Jj0xE`,
	"spaceTop1": `Reviews-spaceTop1-A3RF8`,
	"spaceTop2": `Reviews-spaceTop2-rWcIb`,
	"spaceTop3": `Reviews-spaceTop3-NnHDr`,
	"spaceTop4": `Reviews-spaceTop4-vcwlP`,
	"spaceTop5": `Reviews-spaceTop5-CxjVw`,
	"padding1": `Reviews-padding1-dfmU_`,
	"padding2": `Reviews-padding2-_oMve`,
	"padding3": `Reviews-padding3-vUdcq`,
	"padding4": `Reviews-padding4-xebYN`,
	"padding5": `Reviews-padding5-dW_B2`,
	"paddingTop1": `Reviews-paddingTop1-NGBAZ`,
	"paddingTop2": `Reviews-paddingTop2-xgy1j`,
	"paddingTop3": `Reviews-paddingTop3-Mlwd6`,
	"paddingTop4": `Reviews-paddingTop4-R5_Qf`,
	"paddingTop5": `Reviews-paddingTop5-gBT6n`,
	"noMargin": `Reviews-noMargin-W0GRP`,
	"noPadding": `Reviews-noPadding-auIaM`,
	"noBorder": `Reviews-noBorder-PqPH5`,
	"btn": `Reviews-btn-IS64f`,
	"btnBlock": `Reviews-btnBlock-MOjiO`,
	"formControlSelect": `Reviews-formControlSelect-lSeNd`,
	"splitList": `Reviews-splitList-x1YHH`,
	"displayTable": `Reviews-displayTable-rpy1a`,
	"displayTableRow": `Reviews-displayTableRow-jOlT1`,
	"displayTableCell": `Reviews-displayTableCell-ZJJBo`,
	"displayTableCellIcon": `Reviews-displayTableCellIcon-UlyRB`,
	"textMutedNew": `Reviews-textMutedNew-yvvSv`,
	"tableMarginTop": `Reviews-tableMarginTop-RG_53`,
	"calendarTableCell": `Reviews-calendarTableCell-tR4nV`,
	"vrAlignTop": `Reviews-vrAlignTop-zhWma`,
	"currenyMarginR": `Reviews-currenyMarginR-ZU9MK`,
	"sectionLink": `Reviews-sectionLink-pyvd5`,
	"listingFontSize": `Reviews-listingFontSize-rZJhr`,
	"vrAlignBottom": `Reviews-vrAlignBottom-XV_4G`,
	"introTextPadding": `Reviews-introTextPadding-5fATM`,
	"showHideBtn": `Reviews-showHideBtn-LGcLa`,
	"focus": `Reviews-focus-tTsaU`,
	"showHideMargin": `Reviews-showHideMargin-vrwBc`,
	"listingIntroWidth": `Reviews-listingIntroWidth-KMLk6`,
	"showHidePadding": `Reviews-showHidePadding-XH1gA`,
	"vtrTop": `Reviews-vtrTop-Ozr27`,
	"listingLine": `Reviews-listingLine-JBcEA`,
	"listingLineTwo": `Reviews-listingLineTwo-YOmmh`,
	"responsiveListIngIntro": `Reviews-responsiveListIngIntro-o6fT7`,
	"space6": `Reviews-space6-H4kQB`,
	"space7": `Reviews-space7-tFRmD`,
	"spaceTop8": `Reviews-spaceTop8-Ey6Ni`,
	"spaceTop6": `Reviews-spaceTop6-WP8g3`,
	"spaceTop7": `Reviews-spaceTop7-qOcLN`,
	"padding6": `Reviews-padding6-kPTZJ`,
	"padding7": `Reviews-padding7-u7Siw`,
	"paddingTop6": `Reviews-paddingTop6-O7UC4`,
	"paddingTop7": `Reviews-paddingTop7-Z9Ro6`,
	"textBold": `Reviews-textBold-epKP3`,
	"textBolder": `Reviews-textBolder-Jr9ef`,
	"textNormal": `Reviews-textNormal-wTgbV`,
	"spaceBottom20": `Reviews-spaceBottom20-y4gc5`,
	"spaceBottom10": `Reviews-spaceBottom10-Kzff_`,
	"marginNone": `Reviews-marginNone-P8OwM`,
	"spaceBottom15": `Reviews-spaceBottom15-S9dVJ`,
	"marginTopNone": `Reviews-marginTopNone-chgmD`,
	"spaceTop11": `Reviews-spaceTop11-GsSak`,
	"spaceTop21": `Reviews-spaceTop21-Iw6OE`,
	"spaceTop20": `Reviews-spaceTop20-LYcub`,
	"spaceTop10": `Reviews-spaceTop10-_fLKY`,
	"textDarkBlue": `Reviews-textDarkBlue-IiHEz`,
	"textLightBlue": `Reviews-textLightBlue-B3phg`,
	"textLightSandleGreen": `Reviews-textLightSandleGreen-You9L`,
	"textLightBrown": `Reviews-textLightBrown-him99`,
	"textMediumMaroon": `Reviews-textMediumMaroon-bsgpG`,
	"textBrown": `Reviews-textBrown-jpYVy`,
	"textMaroon": `Reviews-textMaroon-BRfS8`,
	"textDarkBrown": `Reviews-textDarkBrown-YBhbh`,
	"textMediumBrown": `Reviews-textMediumBrown-HhyZq`,
	"textSkyBlue": `Reviews-textSkyBlue-cYxIR`,
	"textGray": `Reviews-textGray-ExZyn`,
	"reviewContainer": `Reviews-reviewContainer-PKntd`,
	"alignMiddle": `Reviews-alignMiddle-ZNyxd`,
	"mediaContainer": `Reviews-mediaContainer-NbX_r`,
	"profileAvatarLink": `Reviews-profileAvatarLink-waG87`,
	"avatarDisplay": `Reviews-avatarDisplay-EN10y`,
	"display": `Reviews-display-WLcFE`,
	"infoAlign": `Reviews-infoAlign-vqjgM`,
	"commentSection": `Reviews-commentSection-N1QpU`,
	"textLeft": `Reviews-textLeft-qJmcv`,
	"btnRadius": `Reviews-btnRadius-Cd9zf`,
	"linkBtn": `Reviews-linkBtn-OXr10`,
	"noBackground": `Reviews-noBackground-h4j7M`,
	"dateCss": `Reviews-dateCss-gWAnl`,
	"borderRadius": `Reviews-borderRadius-bObFQ`,
	"borderMarginTop": `Reviews-borderMarginTop-pPGlQ`
};
module.exports = ___CSS_LOADER_EXPORT___;
